import Vue from 'vue'
import $bizConfig from '@/models/bizConfig.js';
import $web3js from '../web3.js';
import $erc20 from '../erc20/index.js';
import $utils from "@/lib/utils/index.js";

const ifilAbsContract = require('./FPoolProposal.json')

let web3 = $web3js.getWeb3();

let fundBackposalcontractAddress = $bizConfig.fPoolFundBackProposalContractAddress;
let fundBackproposalcontractConst = {
        contract: web3 ? new web3.eth.Contract(ifilAbsContract.abi, fundBackposalcontractAddress) : '',
    }

let proposalcontractAddress = $bizConfig.fPoolProposalContractAddress;
let proposalcontractConst = {
    contract: web3 ? new web3.eth.Contract(ifilAbsContract.abi, proposalcontractAddress) : '',
}

const getFPoolProposalAddress = () => {
        return proposalcontractAddress;
    }

const getFPoolFundBackProposalContract = () => {
        return fundBackproposalcontractConst.contract;
    }

const getFPoolProposalContract = () => {
    return proposalcontractConst.contract;
}

const getFPoolProposalProposals = ([contractAddress, _txIds], options) => {
    if (contractAddress == fundBackposalcontractAddress) {
        return $web3js.call(
            getFPoolFundBackProposalContract().methods.getProposals, [_txIds], options,
            handlFPoolProposalProposalsInfos
        );
    }
    if (contractAddress == proposalcontractAddress) {
        return $web3js.call(
            getFPoolProposalContract().methods.getProposals, [_txIds], options,
            handlFPoolProposalProposalsInfos
        );
    }

};

const handlFPoolProposalProposalsInfos = async(res2) => {


    let resList = [];
    if (res2.length > 0) {
        for (let res of res2) {
            let index = 0;
            let name = res[index++];
            let describe = res[index++];
            let info = res[index++];
            let state = res[index++];
            let infoindex = 0;
            let amount = info[infoindex++];
            let recvAddress = info[infoindex++];
            let expireTime = info[infoindex++];
            let tokenAddress = info[infoindex++];
            let startTime = info[infoindex++];

            amount = await $erc20.fromErc20Value(amount, tokenAddress);
            let symbol = await $erc20.getErc20Symbol([tokenAddress])

            let item = {
                name,
                describe,
                state,
                amount,
                recvAddress,
                expireTime,
                tokenAddress,
                symbol,
                startTime
            }
            resList.push(item);

        }
    }
    return resList;

};

export default {
    getFPoolProposalAddress,
    getFPoolProposalContract,
    getFPoolProposalProposals
}



// WEBPACK FOOTER //
// ./src/lib/contract/fPoolProposal/index.js